<!-- start counter -->
<section class="py-5 position-relative bg-light">
    <div class="container">
        <div class="row text-center gy-4">
            <div class="col-lg-3 col-6">
                <div>
                    <h2 class="mb-2"><span [countUp]="100" class="counter-value" [options]="option"></span>+</h2>
                    <div class="text-muted">Projects Completed</div>
                </div>
            </div>
            <!-- end col -->

            <div class="col-lg-3 col-6">
                <div>
                    <h2 class="mb-2"><span [countUp]="24" class="counter-value" [options]="option"></span></h2>
                    <div class="text-muted">Win Awards</div>
                </div>
            </div>
            <!-- end col -->

            <div class="col-lg-3 col-6">
                <div>
                    <h2 class="mb-2"><span [countUp]="20" class="counter-value" [options]="option"></span>k</h2>
                    <div class="text-muted">Satisfied Clients</div>
                </div>
            </div>
            <!-- end col -->
            <div class="col-lg-3 col-6">
                <div>
                    <h2 class="mb-2"><span [countUp]="50" class="counter-value" [options]="option"></span></h2>
                    <div class="text-muted">Employees</div>
                </div>
            </div>
            <!-- end col -->
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->
</section>
<!-- end counter -->